<template>
  <div
    class="card-image"
    :class="{ clickable: $listeners.click }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="image-container">
      <img
        class="fade"
        v-lazy="{ src: imageUrl, error: lightErrorImage }"
        :alt="alt"
      />
    </div>
  </div>
</template>

<script>
import lightErrorImage from '../images/empty-card-light.png';

export default {
  props: {
    imageUrl: String,
    alt: String,
  },

  data() {
    return {
      lightErrorImage,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.card-image {
  width: var(--card-image-width, 100%);
  max-height: 560px;

  &.clickable {
    cursor: pointer;
  }
}

.image-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-bottom: 170%;
}

img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
}
</style>
